import { useEffect, useState } from 'react';
import { logger } from '../../../utils/logger';
import { AgeCategory, BrandCode } from '../../curriculum';
import { getAdvancePlanningMaterials } from '../api/getAdvancePlanningMaterials';
import { getCurriculumSchedule } from '../api/getCurriculumSchedule';
import { OverviewContent, transformHyfiOverviewContent } from '../models/overviewContent';

const getTransformerByBrandCode = (brandCode: BrandCode) => {
  switch (brandCode) {
    case 'HYFI':
      return transformHyfiOverviewContent;
    default:
      throw new Error(`No transformer defined for brand code: ${brandCode}`);
  }
};

export const useOverviewContent = (brandCode: BrandCode, ageCategory: AgeCategory, curriculumId: string) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [pages, setPages] = useState<OverviewContent[]>([]);

  useEffect(() => {
    Promise.all([getCurriculumSchedule(curriculumId), getAdvancePlanningMaterials(curriculumId)])
      .then(([schedule, advancePlanningVolumes]) => {
        if (!schedule?.volumes?.length) {
          throw new Error('No volumes found in curriculum schedule');
        }

        if (!schedule?.sessions?.length) {
          throw new Error('No sessions found in curriculum schedule');
        }

        const transformer = getTransformerByBrandCode(brandCode);
        const transformedData = transformer(
          brandCode,
          ageCategory,
          schedule.volumes,
          advancePlanningVolumes,
          schedule.sessions
        );
        setPages(transformedData);
        setIsLoading(false);
      })
      .catch(err => {
        logger.error(err);
        setError(err);
        setIsLoading(false);
      });
  }, []);

  return { isLoading, error, pages };
};
